export default __webpack_public_path__ + "static/media/womensclub.11b78b54.png";